import React from 'react';
import ClubSeparator from "../ClubSeparator";
import Club from '../Club';
import Broadcasters from "../Broadcasters";
import MatchTime from "../MatchTime";
import MatchWatch from "../MatchWatch";
import { useMatchData, formatScores, listTypes } from "../../utils";
import MatchShootout from "../MatchShootout/MatchShootout";

const Match = ({ includeMatchWatch = false, includeBroadcasters = false, isFullDate = false, includeTitle = false, position }) => {
  const { homeClubData, awayClubData, listType, references, status, leagueMatchTitle, competition, winnerStatus, period, resultType } = useMatchData();

  const { name: competitionName } = competition || {};
  const title = leagueMatchTitle ? leagueMatchTitle : competitionName;

  const { homeScore, awayScore } = formatScores({
    homeClubData,
    awayClubData,
    period,
    resultType
  });
  const { isHomeWinner, isAwayWinner } = winnerStatus || {};

  return (
    <>
      <div className="mls-o-match-strip__match">
        <div className="mls-o-match-strip__club-group">
          {
            title && includeTitle
              ? <p className="mls-o-match-strip__match-title">{title}</p>
              : null
          }
          <MatchTime isFullDate={isFullDate} />
          <Club isWinner={isHomeWinner} clubData={homeClubData} isHome />
          <ClubSeparator homeScore={homeScore} awayScore={awayScore} status={status} />
          <Club isWinner={isAwayWinner} clubData={awayClubData} isHome={false} />
          {includeMatchWatch ? <MatchWatch position={position} /> : null}
          {listType === listTypes.tv ? null : <MatchShootout />}
        </div>
      </div>
      {includeBroadcasters ? <Broadcasters references={references} listType={listType} /> : null}
    </>
  );
};

export default Match;
